/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
const global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

export { global$1 as g };

//# sourceMappingURL=global-3053f997.js.map